import { useNode } from '@craftjs/core';
import { Box, Stack } from '@mui/material';
import { useCallback } from 'react';

import { useSyncTextEditorState } from '@/components/blockEditor/hooks/useSyncTextEditorState';
import { InputLabel } from '@/components/form/baseInputs/InputLabel';
import { SimpleTextToolbar } from '@/components/TextEditor/plugins/ToolbarPlugin/SimpleTextToolbar';
import { TextEditor } from '@/components/TextEditor/TextEditor';

import { EditableEducationalSlideBodyProps } from './EditableEducationalSlideBody';

export function EducationalSlideBodySettings() {
  const {
    actions: { setProp },
    props,
  } = useNode((node) => ({
    props: node.data.props as EditableEducationalSlideBodyProps,
  }));

  const updateText = useCallback(
    (newContent: string) => {
      setProp((props: EditableEducationalSlideBodyProps) => {
        props.text = newContent;
      });
    },
    [setProp]
  );

  const { editorKey, handleUpdate } = useSyncTextEditorState(
    String(props.text || ''),
    updateText
  );

  return (
    <Stack spacing={2}>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <InputLabel>Text</InputLabel>
        <Box
          sx={{
            borderRadius: '4px',
          }}
        >
          <TextEditor
            key={editorKey}
            initialValue={String(props.text || '')}
            initialValueKind="markdown"
            onUpdate={handleUpdate}
            ToolbarPlugin={SimpleTextToolbar}
          />
        </Box>
      </Box>
    </Stack>
  );
}
